import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export const palletHref = (p, qty = 1) => `/pallet-loader?add=${encodeURIComponent(p.id)}&qty=${qty}`;
export const palletViewHref = (pm) => `/pallet-loader?group=${pm.group}&type=${pm.type_key}`;

export const PalletButtons = ({ p, qty = 1 }) => {
  const navigate = useNavigate();
  if (!p?.pallet) return null;
  return (
    <div className="flex gap-1.5 pt-2 min-w-0" data-testid={`pallet-actions-${p.id}`}>
      <button onClick={() => navigate(palletHref(p, qty))} data-testid={`add-to-pallet-${p.id}`} title="Add to Pallet Loader" className="flex-1 min-w-0 rounded-full bg-ink text-white px-2.5 py-1.5 text-[10px] font-extrabold uppercase tracking-wide inline-flex items-center justify-center gap-1 hover:bg-ink/90 whitespace-nowrap overflow-hidden"><Container size={11} className="shrink-0" /> <span className="truncate"><span className="hidden sm:inline">Add to </span>Pallet Loader</span></button>
      <Link to={palletViewHref(p.pallet)} data-testid={`view-in-pallet-${p.id}`} title="View in Pallet Loader" aria-label="View in Pallet Loader" className="shrink-0 rounded-full border border-ink/30 px-2.5 py-1.5 text-[10px] font-extrabold uppercase tracking-wide inline-flex items-center gap-1 hover:border-ink whitespace-nowrap">View</Link>
    </div>
  );
};

export const PalletPanel = ({ group, products }) => {
  const [cat, setCat] = useState(null);
  useEffect(() => { api.get("/pallet/catalogue").then(({ data }) => setCat(data)).catch(() => {}); }, []);
  if (!cat || !group) return null;
  const g = cat.groups.find((x) => x.key === group);
  const counts = {};
  (products || []).forEach((p) => { if (p.pallet?.group === group) counts[p.pallet.type_key] = (counts[p.pallet.type_key] || 0) + 1; });
  const types = cat.types.filter((t) => t.group === group).sort((a, b) => (counts[b.key] || 0) - (counts[a.key] || 0));
  return (
    <section className="mt-6 rounded-2xl bg-ink text-white p-5" data-testid="search-pallet-panel">
      <div className="flex flex-wrap items-center gap-3">
        <span className="inline-flex items-center gap-2 bg-white/10 rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wider"><Container size={12} /> Pallet Loader · {g?.name || group}</span>
        <p className="text-sm text-white/80">{g?.blurb}</p>
        <Link to={`/pallet-loader?group=${group}`} data-testid="search-pallet-open" className="ml-auto inline-flex items-center gap-1 rounded-full bg-white text-ink px-4 py-1.5 text-xs font-extrabold uppercase">Open loader <ArrowRight size={12} /></Link>
      </div>
      <div className="mt-3 flex gap-2 overflow-x-auto pb-1" data-testid="search-pallet-types">
        {types.map((t) => (
          <Link key={t.key} to={`/pallet-loader?group=${group}&type=${t.key}`} data-testid={`search-pallet-type-${t.key}`} className="shrink-0 rounded-xl border border-white/15 bg-white/5 px-3 py-2 text-xs hover:bg-white/10">
            <div className="font-semibold whitespace-nowrap">{t.name}</div>
            <div className="text-white/60">{counts[t.key] ? `${counts[t.key]} in results` : "quote-first"}</div>
          </Link>))}
      </div>
    </section>
  );
};
